import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('parameterTypeStore', 'unitStore')
@observer
class ParameterTypeModify extends Component {
  render() {
    const { parameterTypeStore, unitStore, params } = this.props;

    return (
      <ItemModify
        title='Parameter Type'
        slug='/parameter-type'
        store={parameterTypeStore}
        itemFields={[
          { label: 'Id', key: 'id', type: 'text', readOnly: true, editOnly: true },
          { label: 'Name', key: 'name', type: 'text' },
          { label: 'Unit', key: 'parameter_unit_id', type: 'select', options: unitStore.items, fields: { label: 'name', value: 'id' } },
        ]}
        params={{ id: params.parameterTypeId }}
      />
    )
  }
}

export default ParameterTypeModify;



// WEBPACK FOOTER //
// ./src/components/ParameterType/ParameterTypeModify.js